import React from "react";
import ChatList from "./widget/ChatList";
import { ChatsContentType } from "../../../libraries/types_interface/chats/ChatsTypes";
import Div from "../../../widget/common/ui/Div";

const ChatsContent: React.FC<ChatsContentType> = ({ chats, type }) => {
  return (
    <Div className="pt-2">
      <ChatList chats={chats} type={type} />
    </Div>
  );
};

export default ChatsContent;
